//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import { createPopper, flip, preventOverflow } from '@/libs/popper'
import searchInput from '~/mixins/search/search-input'
import { debounce } from '~/utils/v'
import numberWithCommas from '~/filters/numberWithCommas'
import highlightFilter from '~/filters/highlight'

export default {
  name: 'SearchLocationInput',
  mixins: [searchInput],
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    alwaysOpenList: {
      type: Boolean,
      default: false
    },
    initialLocations: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      popper: null,
      listIsOpen: false,
      maxSelectedItems: 3,
      maxListItems: 8,

      inputText: '',
      inputList: [],
      isProcessingClickOutside: false,
      clickOutsideTimeout: null,
      clickOutsideDelay: 150,
      timeout: 300,
      timer: null,
      busy: false
    }
  },
  computed: {
    ...mapState({
      locationsFull: state => state.search.locationsFull
    }),
    ...mapGetters({
      locale: 'lang/locale',
      autocomplete: 'search/autocomplete'
    }),
    inputModel: {
      get () {
        return this.inputText
      },
      set (value) {
        clearTimeout(this.timer)
        this.busy = true
        this.inputText = value
        this.$emit('input', this.inputText)
        this.getAutocomplete()
        this.timer = setTimeout(() => this.busy = false, this.timeout)
      }
    },
    isMaxSelected () {
      return this.inputList.length >= this.maxSelectedItems
    },
    autocompleteLoading () {
      return this.busy || this.autocomplete.loading
    },
    autocompleteNotFound () {
      return !this.busy && !this.autocomplete.loading && (!this.autocomplete.data?.length && !!this.inputModel)
    },
    getSelectedListItems () {
      if (this.inputList?.length) {
        return this.inputList
      }
      return this.fillInput()
    },
    hasSelectedListItems () {
      return this.getSelectedListItems?.length
    },
    getListItems () {
      const selected = this.getSelectedListItems
      let maxAutocomplete = this.maxListItems
      let maxPopular = this.maxListItems
      if (this.hasSelectedListItems) {
        maxAutocomplete -= 2
        maxPopular -= (3 + (this.autocompleteNotFound ? 1 : 0))
      }
      if (this.isMaxSelected) {
        maxAutocomplete -= 1
        maxPopular -= 1
      }
      const autocomplete = (this.autocomplete.data
        ?.filter(i => !selected.some(selectedItem => selectedItem.id === i.id)) || [])
        ?.slice(0, maxAutocomplete)
      const popular = (this.autocomplete.popular
        ?.filter(i => !selected.some(selectedItem => selectedItem.id === i.id)) || [])
        ?.slice(0, maxPopular)

      if (!autocomplete?.length) {
        return {
          selected,
          popular
        }
      } else if (autocomplete?.length) {
        return {
          selected,
          autocomplete
        }
      } else {
        return {
          //   selected,
          //   autocomplete
        }
      }
    },
    hasListItems () {
      return !!Object.values(this.getListItems).find(i => i.length)
    },
    listItemSelected: app => (id) => {
      return !!app.inputList.find(i => parseInt(i.id, 10) === parseInt(id, 10))
    }
  },
  created () {
    this.$store.dispatch('search/getAutocompletePopular')
  },
  mounted () {
    this.popper = createPopper(this.$el, this.$refs['list-container'], {
      strategy: 'absolute',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 16]
          }
        },
        preventOverflow,
        flip
      ],
      placement: 'bottom-start'
    })

    setTimeout(() => {
      this.$Search.getAttributeValue('locations').map((slug) => {
        if (this.initialLocations?.length) {
          this.setSelectedListItems(this.initialLocations)
        } else {
          const location = [...this.locationsFull || []].find(l => l.urls[l.type] === slug)
          if (location) {
            this.toggleListItem({
              id: location.ids[location.type],
              name: location.location[location.type],
              slug: location.urls[location.type],
              boat_count: location.count,
              type: location.type,
              country_code: '',
              short_code: ''
            })
          }
        }
      })
    }, 200)
  },
  beforeDestroy () {
    if (this.clickOutsideTimeout) {
      clearTimeout(this.clickOutsideTimeout)
    }
  },
  methods: {
    startSearch() {
      this.$emit('close')
      this.$modal.hide('search-destination-input-modal')
    },
    fillInput() {
      this.inputList = this.initialLocations
      return this.inputList
    },
    highlightFilter,
    numberWithCommas,
    getAutocomplete: debounce(function () {
      if (this.inputModel) {
        this.$store.dispatch('search/getAutocomplete', this.inputModel)
      } else {
        this.$store.commit('search/SET_AUTOCOMPLETE', { data: [], loading: false })
      }
    }, 300),
    toggleListItem (location) {
      if (this.listItemSelected(location.id)) {
        this.inputList = this.inputList.filter(i => parseInt(i.id, 10) !== parseInt(location.id, 10))
      } else if (this.inputList.length < this.maxSelectedItems) {
        this.inputList = [...this.inputList, location]
        this.clearInput()
      }
      this.$emit('list', this.inputList)
      setTimeout(() => {
        this.$scrollTo({ x: 10000 }, this.$refs['input-selected-container'])
      }, 0)
    },
    setSelectedListItems (locations) {
      this.inputList = locations
      this.$emit('list', this.inputList)
    },
    onClick () {
      this.openList()
    },
    openList () {
      this.listIsOpen = true
      this.isProcessingClickOutside = true

      if (this.clickOutsideTimeout) {
        clearTimeout(this.clickOutsideTimeout)
      }

      this.clickOutsideTimeout = setTimeout(() => {
        this.isProcessingClickOutside = false
      }, this.clickOutsideDelay)
    },
    closeList () {
      this.listIsOpen = false
    },
    handleClickOutside () {
      if (!this.isProcessingClickOutside) {
        this.closeList()
      }
    },
    clearInput () {
      this.inputModel = ''
    }
  }
}
